import { getLocale } from "../runtime";

const sv_sicountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Slovenien`
};

const sicountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_sicountry(inputs)
	return "siCountry";
};

export { sicountry as "siCountry" };